// Roman Numeral Converter Tool — number ↔ Roman numeral (1–3999).
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const romanNumeralTool: Tool = {
  id: "roman-numeral",
  name: () => m.rn_tool_name(),
  description: () => m.rn_tool_description(),
  icon: "🏛️",
  basePath: "/roman-numeral",
  status: "stable",
  tags: ["roman", "numeral", "number", "converter"],
  pages: [
    {
      name: () => m.rn_nav_main(),
      path: "/roman-numeral",
      description: () => m.rn_nav_main_desc(),
      icon: "🏛️",
    },
  ],
};
